import { UserNoDates } from "@/types/types";

export const getMaxUploadMinutesLimit = (
  user: UserNoDates | null,
  maxMinutesToUpload: number
): number => {
  if (user === null) {
    return maxMinutesToUpload;
  }

  if (user.dbId === "bc745849-6324-42a1-9359-28ed9ea2fb48") {
    return 6000;
  }

  if (user.clerkId === "user_2nCXqOpnKNM1WBSHrEGSdDBbode") {
    return 120;
  }

  return maxMinutesToUpload;
};
